import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getBonusesPersonal = () => {
    return axios.get(`${backendHost}/api/admin/bonuses/list/personal`);
};

export {
    getBonusesPersonal
}